import React from "react";
import styled from "styled-components";
import { getCsrfToken } from "../util";
import { brand_orange_deep, dark } from "../constants/styles";

// Native <form> submit to /google_sign_in/authorization. The `google_sign_in`
// gem reads `proceed_to` from the POST and round-trips it via flash across
// the Google OAuth redirect, so `redirect_after_login` survives the whole
// trip and `GoogleLoginsController#create` eventually consumes it.
//
// Props:
//   proceedTo — URL built server-side (create_login_google_url?redirect_after_login=…)
//   label     — "Masuk dengan Google" / "Daftar dengan Google"
const Form = styled.form`
  width: 100%;
  display: block;
`;

const Button = styled.button`
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  background: #ffffff;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 120ms ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${brand_orange_deep};
    outline-offset: 2px;
  }

  [data-theme="dark"] & {
    background: ${dark.surface_bg};
    color: ${dark.text_primary};
    border-color: rgba(255, 255, 255, 0.1);

    &:hover {
      background: ${dark.surface_raised};
    }
  }
`;

const GoogleLogo = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g fill="none" fillRule="evenodd">
      <path d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.88 2.68-6.62z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.35 0-4.34-1.58-5.05-3.72H.9v2.34A8.99 8.99 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.95 10.7A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.16.27-1.7V4.96H.9A8.99 8.99 0 0 0 0 9c0 1.45.35 2.82.9 4.04l3.05-2.34z" fill="#FBBC05"/>
      <path d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58A8.99 8.99 0 0 0 9 0 8.99 8.99 0 0 0 .9 4.96L3.95 7.3C4.66 5.16 6.65 3.58 9 3.58z" fill="#EA4335"/>
    </g>
  </svg>
);

export default function GoogleSignInButton({ proceedTo, label }) {
  return (
    <Form method="POST" action="/google_sign_in/authorization">
      <input type="hidden" name="authenticity_token" value={getCsrfToken() || ""} />
      {proceedTo && <input type="hidden" name="proceed_to" value={proceedTo} />}
      <Button type="submit">
        <GoogleLogo />
        <span>{label}</span>
      </Button>
    </Form>
  );
}
